import { render, staticRenderFns } from "./CompanyFormEdit.vue?vue&type=template&id=155b88fc&scoped=true"
import script from "./CompanyFormEdit.vue?vue&type=script&lang=js"
export * from "./CompanyFormEdit.vue?vue&type=script&lang=js"
import style0 from "./CompanyFormEdit.vue?vue&type=style&index=0&id=155b88fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155b88fc",
  null
  
)

export default component.exports